<div class="pagination">
  <div class="pagination__label">
    Showing <strong>{{ start() }}–{{ end() }}</strong> of <strong>{{ total() }}</strong>
  </div>
  @if (showControls()) {
  <div class="pagination__controls">
    <button
      class="pagination__btn"
      [disabled]="page() === 1"
      [class.pagination__btn--disabled]="page() === 1"
      (click)="go(page() - 1)">
      <span class="material-symbols-outlined">chevron_left</span>
    </button>
    @for (n of pages(); track $index) {
      @if (n === '...') {
        <span class="pagination__ellipsis">…</span>
      } @else {
        <button
          class="pagination__btn"
          [class.pagination__btn--active]="n === page()"
          (click)="go(n)">
          {{ n }}
        </button>
      }
    }
    <button
      class="pagination__btn"
      [disabled]="page() === totalPages()"
      [class.pagination__btn--disabled]="page() === totalPages()"
      (click)="go(page() + 1)">
      <span class="material-symbols-outlined">chevron_right</span>
    </button>
  </div>
  }
</div>
